<template>
  <div>
    <vxe-grid
      ref="table"
      size="small"
      row-id="amzSkuSpecCode"
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="500"
      :checkbox-config="{
        highlight: true,
        reserve: true,
        checkRowKeys: checkRowKeys,
      }"
      :edit-config="{
        enabled: !disabled,
        trigger: 'click',
        mode: 'cell',
      }"
    >
      <template v-slot:toolbar_form>
        <slot name="header">
          <div class="text_cl">
            {{
              $l('INDEX.amz_sku_label_Specific') || '勾选使用该物料的具体产品规格'
            }}
          </div>
        </slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>

      <template v-slot:defaultImageUrl="{ row }">
        <el-image
          :src="
            row.defaultImageUrl
              ? $osscdn(row.defaultImageUrl)
              : '/image/static/img/nopic-square.jpg'
          "
          :preview-src-list="[
            row.defaultImageUrl
              ? $osscdn(row.defaultImageUrl)
              : '/image/static/img/nopic-square.jpg',
          ]"
          style="width:60px; height:60px"
        >
          <div slot="error" class="image-slot">
            <img
              src="/image/static/img/nopic-square.jpg"
              style="width:60px; height:60px"
            />
          </div>
        </el-image>
      </template>
      <template v-slot:specName="{ row }">
        <span>{{ row.specName }}</span>
        <br />
        <span>{{ row.specNameEn }}</span>
        <br />
        <span>{{ row.specNo }}</span>
      </template>
      <template v-slot:goodsLength="{ row }">
        <span
          >{{ row.goodsLength }}*{{ row.goodsWidth }}*{{ row.goodsHeight }}
          {{ !!row.specQty ? 'x' + row.specQty : '' }}
        </span>
      </template>

      <template v-slot:fabricContent="{ row }">
        <span>{{ row.fabricContent }}</span>
        <br />
        <span>{{ row.fabricContentEn }}</span>
      </template>

      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import EditLoading from '@/mixins/edit-loading'
import tableColumns from './table-columns'
export default {
  mixins: [EditLoading],
  props: {
    tablePage: { type: Object, default: () => {} },
    tableHeight: { type: Number, default: 300 },
    amzSkuCode: { type: String, default: '' },
    amzSkuMaterialCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
      },
      loading: false,
      tableColumns: tableColumns(this),
      tableData: [],
      checkRowKeys: [],
    }
  },
  mounted() {
    this.getData()
  },
  computed: {},
  methods: {
    getData() {
      this.loading = true
      this.$api
        .ecomAmzSkuSpecMaterialListApi({
          amzSkuCode: this.amzSkuCode,
          amzSkuMaterialCode: this.amzSkuMaterialCode,
        })
        .then((res) => {
          this.loading = false
          this.tableData = res.body.data
          this.loadData(this.tableData)
        })
        .catch(() => {
          this.loading = false
        })
    },
    loadData(data) {
      this.checkRowKeys = []
      data.forEach((item) => {
        if (item.amzSkuSpecMaterialCode)
          this.checkRowKeys.push(item.amzSkuSpecCode)
      })
    },

    getCheckboxRecords() {
      const data = this.$refs.table
        .getCheckboxRecords()
        .concat(this.$refs.table.getCheckboxReserveRecords())
      return data
    },
  },
}
</script>
<style lang="scss" scoped>
.text_cl {
  font-size: 1rem;
  font-weight: 600;
  line-height: 1.5;
  color: #212529;
  text-align: left;
}
</style>
